function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "bag",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  fill: "#C4C4C4",
  stroke: "#04223B",
  strokeLinecap: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#bag)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.8333 10.6667C15.8333 11.5507 15.4821 12.3986 14.857 13.0237C14.2319 13.6488 13.3841 14 12.5 14C11.6159 14 10.7681 13.6488 10.143 13.0237C9.51786 12.3986 9.16667 11.5507 9.16667 10.6667M7.5 4L5 7.33333V19C5 19.9167 5.75 20.6667 6.66667 20.6667H18.3333C18.7754 20.6667 19.1993 20.4911 19.5118 20.1785C19.8244 19.8659 20 19.442 20 19V7.33333L17.5 4H7.5ZM5.66667 7.33333H19.3333H5.66667Z",
  stroke: "#04223B",
  strokeWidth: 1.66667,
  strokeLinecap: "round"
}));

var SvgCartBag = function SvgCartBag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCartBag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart-bag.72ab8391.svg";
export { ForwardRef as ReactComponent };